<template>
  <div v-if="visible">
    <div class="dim">
      <div class="modal" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
          <div class="modal-content" >
            <div class="modal-header">
              <h4 class="modal-title" id="myModalLabel">채널 등록하기</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close()"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body">
              <table class="table table-hover table-bordered">
                <tr>
                  <th>*채널 ID</th>
                  <td><input v-model="pop.channelId" type="text" class="form-control" @keyup.enter="getTutors()"/></td>
                </tr>
                <tr>
                  <th>채널 이름</th>
                  <td><input v-model="pop.channelTitle" type="text" class="form-control" @keyup.enter="getTutors()"/></td>
                </tr>
              </table>
            </div>
            <div class="modal-body text-center">
              <button @click="insertChannel" class="btn btn-primary">등록</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'tutorModal',
  props: {
    visible: {
      type: Boolean,
      require: true,
      default: false
    },
    pickSeries: {},
  },

  data: () => ({
    tutors: [],
    seriesInput: {},
    pop:{
      id: '',
      name: '',
    },
    tutor:{

    }
  }),

  watch: {
    visible: function (newVal) {
      if (newVal === true) {
        this.visible = true;
        // this.doSearch();
      } else {
        this.visible = false;
      }
    }
  },
  mounted() {

  },

  methods: {
    close() {
      this.$emit("close", false);
    },

    insertChannel: function (idx) {
      if(confirm('입력 하시겠습니까?')){
        if(this.pop.channelId === null ||  this.pop.channelId === '' || this.pop.channelId === undefined){
          alert("채널 ID를 입력하세요.")
        } else {
          const url = '/v1/api/admin/pick4u/channels'
          const params = this.getParams({
            channelId: this.pop.channelId
            , channelTitle: this.pop.channelTitle
          })
          this.axios.post(url, params)
          .then(res => {
            if (res.data.err === 0) {
              alert('입력이 완료되었습니다.')
              this.close()
            }
          }).catch(err => {
            if (err.response.data.path === '/login/msg') {
              alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
              this.$router.push('/login')
            } else {
              alert('관리자에게 문의하세요')
            }
          })
        }
      }
    },
  }
}
</script>

<style scoped>
.dim {
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  box-sizing: border-box;
  z-index: 1000;
}

.modal {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/popChannelAdd.vue